import React, { useState } from 'react';

export const useAggregatedState = (source) => {

    const [state, _setState] = useState(source);
    const setState = (newState) => {
        _setState(prevState => {
            return Object.assign({ ...prevState }, newState);
        });
    };

    return [state, setState];
}

export const useBusyState = (source) => {

    const [state, _setState] = useState(source);
    const setIsBusy = (newState) => {
        _setState(prevState => {
            return Object.assign({ ...prevState }, newState);
        });
    };

    const isBusy = (state) => (key) => {
        if (key) {
            return state[key] ? state[key] === true : false;
        } else {
            const keys = Object.keys(state).filter(key => key[0] !== "_");
            for (var index in keys) {
                key = keys[index];
                if (state[key] === true) return true;
            }
            return false;
        }
    }

    return [state, isBusy(state), setIsBusy];
}